// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cahandle{min-height:600px}.cahandle .box-card{width:1000px;margin:120px auto}.cahandle .box-card .el-row{margin-top:40px}.cahandle .box-card .clearfix{text-align:center}.cahandle .box-card .clearfix span{font-size:20px}.cahandle .box-card .text{text-align:right;line-height:36px}.cahandle .box-card .text .label{font-size:18px;color:#1890ff}.cahandle .box-card .text .label:after{content:\"*\";color:#f56c6c;margin-right:4px}.cahandle .box-card .text .el-input-number{width:100%}.cahandle .box-card .text .el-input-number .el-input__inner{text-align:left!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryColor": "#2252e7",
	"primaryColor9": "#3863e9",
	"primaryColor8": "#4e75ec",
	"primaryColor7": "#6486ee",
	"primaryColor6": "#7a97f1",
	"primaryColor5": "#91a9f3",
	"primaryColor4": "#a7baf5",
	"primaryColor3": "#bdcbf8",
	"primaryColor2": "#d3dcfa",
	"primaryColor1": "#e9eefd",
	"successColor": "#52c41a",
	"successColor9": "#63ca31",
	"successColor8": "#75d048",
	"warningColor": "#faad14",
	"warningColor9": "#fbb52c",
	"warningColor8": "#fbbd43",
	"dangerColor": "#ef4040",
	"dangerColor9": "#f15353",
	"dangerColor8": "#f26666",
	"infoColor": "#909399",
	"infoColor9": "#9b9ea3",
	"infoColor8": "#a6a9ad",
	"navBgColor": "#304156",
	"navTextColor": "#bfcbd9",
	"navTextActiveColor": "#ffd04b"
};
module.exports = ___CSS_LOADER_EXPORT___;
